/*
 * (c) Copyright 2024 Calabrio, Inc.
 * All Rights Reserved. www.calabrio.com LICENSED MATERIALS
 * Property of Calabrio, Inc., Minnesota, USA
 *
 * No part of this publication may be reproduced, stored or transmitted,
 * in any form or by any means (electronic, mechanical, photocopying,
 * recording or otherwise) without prior written permission from Calabrio, Inc.
 */
import AutoQAService from '../../service/autoQA.js';
import WyUtils from '../../library/wy-utils.js';
import WyFilter from '../../library/wy-filter.js';
import moment from 'moment-timezone';

const state = {
  
};

const getters = {
  
};

const mutations = {
  
};

const actions = {
  async fetchChatFilters({ getters, dispatch, rootState }, { pageName }) {
    return new Promise(async (resolve) => {
      const dataModel = rootState.site.pages[pageName].dataModel;

      if (!getters.localStorage.agentData) {
        dataModel.filters = {
          agentGroups: { label: 'Group', name: 'agentGroups', value: null, type: 'multiSelectCheckbox', placeholder: 'Search agent groups' },
          agentTeams: { label: 'Team', name: 'agentTeams', value: null, type: 'multiSelectCheckbox', placeholder: 'Search teams' },
          agents: { label: 'Agent', name: 'agents', value: null, type: 'multiSelectCheckbox', placeholder: 'Search agents' },
          topics: { label: 'Topics', name: 'topics', value: null, type: 'hidden' },
          formId: {label: 'Form', name: 'formId', value: '', type: 'checkbox', isRequire: true},
          contactTypes: { label: 'Contact Types', name: 'contactTypes', value: null, type: 'multiSelectCheckbox', placeholder: 'Search contact types' },
          languages: { label: 'Language', name: 'languages', value: null, type: 'multiSelectCheckbox', placeholder: 'Search languages', category: 'moreFilters' },
          directions: { label: 'Direction', name: 'directions', value: '', type: 'checkbox', isRequire: true, category: 'moreFilters' },
          channels: { label: 'Channels', name: 'channels', value: null, type: 'multiSelectCheckbox', placeholder: 'Search channels', category: 'moreFilters' },
        };

        let res = await AutoQAService.fetchChatFilters(getters.authUser);
        if (res && res.status == 200 && res.data) {
          await dispatch('updateLocalStorage', { key: 'agentData', data: {
            agentGroups: res.data.agentGroups,
            agentTeams: res.data.agentTeams,
            agents: res.data.agents
          }});
          // date limits
          if (res.data.dateLimits && res.data.dateLimits.length > 0) {
            dataModel.dateMin = res.data.dateLimits[0].firstDate;
            dataModel.dateMax = res.data.dateLimits[0].lastDate;
          }

          // agentGroups list
          if (dataModel.filters.agentGroups) {
            dataModel.filters.agentGroups.dataSource = (res.data.agentGroups || []).map((item) => {
              return { key: item.groupId, label: item.groupName };
            });
            dataModel.filters.agentGroups.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            dataModel.filters.agentGroups.dataSource.unshift({ key: 'all', label: 'All' });
          }

          // agentTeams list
          if (dataModel.filters.agentTeams) {
            dataModel.filters.agentTeams.dataSource = (res.data.agentTeams || []).map((item) => {
              return { key: item.teamId, label: item.teamName, groupId: item.groupId };
            });
            dataModel.filters.agentTeams.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            dataModel.filters.agentTeams.dataSource.unshift({ key: 'all', label: 'All' });
          }

          // agents list
          if (dataModel.filters.agents) {
            dataModel.filters.agents.dataSource = (res.data.agents || []).map((item) => {
              return { key: item.agentId, label: item.agentName, teamId: item.teamId, groupId: item.groupId };
            });
            dataModel.filters.agents.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            dataModel.filters.agents.dataSource.unshift({ key: 'all', label: 'All' });
          }
          // direction list
          //mockdata: 
          res.data.directions = [
            {
              "direction": "inbound"
            },
            {
              "direction": "outbound"
            }
          ]
          if (dataModel.filters.directions) {
            const directionsMap = getters.authUser.config.app.configs.directionsMapping || {};
            // const directionsMap = getters.authUser.config.app.configs.directionsMapping || {'all': "All"};
            dataModel.filters.directions.dataSource = (res.data.directions || []).map((item) => {
              return { key: item.direction, label: directionsMap[item.direction] && directionsMap[item.direction] != '' ? directionsMap[item.direction] : WyUtils.toCamelCase(item.direction) };
            });
            dataModel.filters.directions.dataSource.unshift({ key: '', label: 'All' });
            dataModel.filters.directions.value = '';
          }
          if (dataModel.filters.formId) {
            dataModel.filters.formId.dataSource = res.data.formList
            dataModel.filters.formId.value = (res.data.formList && res.data.formList.length > 0) ? res.data.formList[0].formId : ''
          }

          // languages list
          //mockdata: 
          // res.data.languages = [
          //   {languageId: 'en', languageName: 'English'},
          //   {languageId: 'fr', languageName: 'French'}
          // ]
          if (dataModel.filters.languages) {
            dataModel.filters.languages.dataSource = (res.data.languages || []).map((item) => {
              return { key: item.languageId, label: item.languageName };
            });
            dataModel.filters.languages.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            if(dataModel.filters.languages.dataSource.length > 1) {
              dataModel.filters.languages.dataSource.unshift({ key: 'all', label: 'All' });
            }
            else if(dataModel.filters.languages.dataSource.length == 1){
              // dataModel.filters.languages.value = [dataModel.filters.languages.dataSource[0].key];
              dataModel.filters.languages.value = [];
            }
            else {
              dataModel.filters.languages.value = [];
            }
          }
          if (dataModel.filters.contactTypes) {
            dataModel.filters.contactTypes.dataSource = (res.data.contactTypes || []).map((item) => {
              return { key: item.contactTypeKey, label: item.contactTypeName };
            });
            dataModel.filters.contactTypes.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            if(dataModel.filters.contactTypes.dataSource.length > 1) {
              dataModel.filters.contactTypes.dataSource.unshift({ key: 'all', label: 'All' });
            }
            else if(dataModel.filters.contactTypes.dataSource.length == 1){
              // dataModel.filters.contactTypes.value = [dataModel.filters.contactTypes.dataSource[0].key];
              dataModel.filters.contactTypes.value = [];
            }
          }
          if (dataModel.filters.channels) {
            dataModel.filters.channels.dataSource = (res.data.channels || []).map((item) => {
              return { key: item.channelKey, label: item.channelName };
            });
            dataModel.filters.channels.dataSource.sort((a, b) => a.label.localeCompare(b.label))
            if(dataModel.filters.channels.dataSource.length > 1) {
              dataModel.filters.channels.dataSource.unshift({ key: 'all', label: 'All' });
            }
            // comment out this due to this ticket issue  1078014
            // else if(dataModel.filters.channels.dataSource.length == 1){
            //   // dataModel.filters.channels.value = [dataModel.filters.channels.dataSource[0].key];
            //   dataModel.filters.channels.value = [];
            // }
          }

          // set iframe selected filters
          WyFilter.setIFrameSelectedFilters(dataModel);

          // reset appliedFiltersCounter to 0
          dataModel.appliedFiltersCounter = 0;

          await dispatch('initFilterOriginalSource');
          resolve();
        } else {
          resolve();
        }
      } else {
        resolve();
      }
    });
  },

  async fetchAutoQAEvalForm({ getters }, payload) {
    return AutoQAService.fetchAutoQAEvalForm(getters.authUser, payload);
  },

  async fetchAutoQAEvalFormDropdown({ getters }, payload) {
    return AutoQAService.fetchAutoQAEvalFormDropdown(getters.authUser, payload);
  },

  async saveAutoQAEvalFormOverride({ getters }, payload) {
    return AutoQAService.saveAutoQAEvalFormOverride(getters.authUser, payload);
  },

  async fetchAutoQAEvalDataInsightScoresData({ getters }, payload) {
    return AutoQAService.fetchAutoQAEvalDataInsightScoresData(getters.authUser, payload);
  },

  async fetchAutoQAEvalTopicGroupData({ getters }, payload) {
    return AutoQAService.fetchAutoQAEvalTopicGroupData(getters.authUser, payload);
  },


  async fetchSmartTagsDataOnMediaPlayer({ getters }, payload) {
    return AutoQAService.fetchSmartTagsDataOnMediaPlayer(getters.authUser, payload);
  },

  async fetchAutoQAEvalPageFilters({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    if(options && options.agents) {
      payload.agents = options.agents;
    }
    return AutoQAService.fetchAutoQAEvalPageFilters(getters.authUser, payload);
  },

  async fetchAutoQAEvalQuestionList({ getters }) {
    return AutoQAService.fetchAutoQAEvalQuestionList(getters.authUser);
  },

  async fetchAutoQAEvalFormById({ getters }, formId) {
    return AutoQAService.fetchAutoQAEvalFormById(getters.authUser, formId);
  },

  async fetchAutoEvalFormList({ getters }, payload) {
    return AutoQAService.fetchAutoEvalFormList(getters.authUser, payload);
  },
  
  async deleteAutoEvalForm({ getters }, payload) {
    return AutoQAService.deleteAutoEvalForm(getters.authUser, payload);
  },

  async cloneAutoEvalForm({ getters }, payload) {
    return AutoQAService.cloneAutoEvalForm(getters.authUser, payload);
  },

  async updateAutoEvalForm({ getters }, payload) {
    return AutoQAService.updateAutoEvalForm(getters.authUser, payload);
  },

  async publishAutoEvalForm({ getters }, payload) {
    return AutoQAService.publishAutoEvalForm(getters.authUser, payload);
  },

  async lockAutoEvalForm({ getters }, payload) {
    return AutoQAService.lockAutoEvalForm(getters.authUser, payload);
  },

  async unlockAutoEvalForm({ getters }, payload) {
    return AutoQAService.unlockAutoEvalForm(getters.authUser, payload);
  },

  async archiveAutoEvalForm({ getters }, payload) {
    return AutoQAService.archiveAutoEvalForm(getters.authUser, payload);
  },

  async fetchAutoQAEvalQuestionById({ getters }, questionId) {
    return AutoQAService.fetchAutoQAEvalQuestionById(getters.authUser, questionId);
  },

  async fetchAutoCustomEvalQuestionList({ getters }, payload) {
    return AutoQAService.fetchAutoCustomEvalQuestionList(getters.authUser, payload);
  },
  async fetchAutoQAMetadataList({ getters }, payload) {
    return AutoQAService.fetchAutoQAMetadataList(getters.authUser, payload);
  },
  
  async deleteAutoEvalQuestion({ getters }, payload) {
    return AutoQAService.deleteAutoEvalQuestion(getters.authUser, payload);
  },

  async cloneAutoEvalQuestion({ getters }, payload) {
    return AutoQAService.cloneAutoEvalQuestion(getters.authUser, payload);
  },

  async updateAutoEvalQuestion({ getters }, payload) {
    return AutoQAService.updateAutoEvalQuestion(getters.authUser, payload);
  },

  async publishAutoEvalQuestion({ getters }, payload) {
    return AutoQAService.publishAutoEvalQuestion(getters.authUser, payload);
  },

  async lockAutoEvalQuestion({ getters }, payload) {
    return AutoQAService.lockAutoEvalQuestion(getters.authUser, payload);
  },

  async unlockAutoEvalQuestion({ getters }, payload) {
    return AutoQAService.unlockAutoEvalQuestion(getters.authUser, payload);
  },

  async archiveAutoEvalQuestion({ getters }, payload) {
    return AutoQAService.archiveAutoEvalQuestion(getters.authUser, payload);
  },

  async fetchBesBasContactReasonsSummary({getters, commit}, {targetRange}) {
    let results = [];
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await AutoQAService.fetchBesBasContactReasonsSummary(getters.authUser, payload);
    if(res && res.status === 200 && res.data) {
      let sumTotalVolume = res.data.totalVolume; // this line is for V4 OC_V1.4.0
      let items = res.data.items;
      if(!items) {
        // for v3 backward compability
        sumTotalVolume = res.data.reduce((total, item) => { return total+item.totalVolume; }, 0);
        items = res.data;
      }

      Object.keys(items).forEach((key) => {
        let item = items[key];
        
        for(const key in item){
          if(item[key] == -1){
            item[key] = 'N/A'
          }
        }

        // item.volumePercent = item.volumePercent * 100;
        item.volumePercent = (item.totalVolume/sumTotalVolume * 100).toFixed(2); 
        // item.besPercent = -1
        item.besPercentOrigin = item.besPercent
        item.basPercentOrigin = item.basPercent
        if(item.besPercent == -1 || item.besPercent == 'N/A'){
          item.besPercent = 'N/A';
        } 
        else {
          item.besPercent = Math.round(item.besPercent * 100);
        }
        if(item.basPercent == -1 || item.basPercent == 'N/A'){
          item.basPercent = 'N/A';
        } 
        else {
          item.basPercent = Math.round(item.basPercent * 100);
        }
        if(targetRange){
          if(targetRange[item.topicDisplayName]) {
            item.besTarget = targetRange[item.topicDisplayName].bes;
            item.basTarget = targetRange[item.topicDisplayName].bas;
          }
          else if(targetRange['default']) {
            item.besTarget = targetRange['default'].bes;
            item.basTarget = targetRange['default'].bas;

            // new UI config
            if ((targetRange['default'].bes && targetRange['default'].bes.maxValue) || (targetRange['default'].bas && targetRange['default'].bas.maxValue)) {
              item.besTarget = { maxValue: targetRange['default'].bes && targetRange['default'].bes.maxValue }
              item.basTarget = { maxValue: targetRange['default'].bas && targetRange['default'].bas.maxValue }
            }
          }
        }
        results.push(item);
      })
      
      commit('updateTableModelResult', {
        results: results, 
        totalRecs: results.length, 
        totalPages: 1
      })

      return new Promise((resolve) => {
        resolve(true)
      })
    }
    else {
      return new Promise((resolve) => {
        resolve(false)
      })
    }
    
  },

  async fetchAutoQAPerformanceScores({ getters }, {viewBy}) {
    const payload = {
      ...WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A),
      viewBy: viewBy
    }
    
    const res = await AutoQAService.fetchAutoQAPerformanceScores(getters.authUser, payload);
    return res.data;
  },

  async fetchAutoQAGroupTeamTableData({getters, commit}, options) {
    let payload = {
      ...WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A)
    }
    payload[options.type] = options.value;
    payload.tableType = options.tableType;
    payload.sortColumn = options.sortColumn;
    payload.sorting = options.sorting;
    payload.pageSize = options.pageSize;
    payload.pageNumber = options.pageNumber;
    let res = await AutoQAService.fetchAutoQAEvalGroupTeamTableSummary(getters.authUser, payload);
    if(res && res.data && res.data.results.length > 0) {
      res.data.results.forEach(item => {
        item.overallScoreDisplay = item.overallScore.toFixed(2);
        res.data.sections.forEach(section => {
          let displayColumn = (section.replace(/\s(.)/g, function (a) {
            return a.toUpperCase();
          })
          .replace(/\s/g, '')
          .replace(/^(.)/, function (b) {
              return b.toLowerCase();
          })) + 'Display'
          item[displayColumn] = item[section].toFixed(2);
        })
      })

      commit('updateTableModelResultWithDynamicColumns', {
        results: res.data.results, 
        totalRecs: res.data.totalRecords, 
        totalPages: res.data.totalPages,
        sections: res.data.sections
      })
    }
    else {
      commit('updateTableModelResultWithDynamicColumns', {
        results: [], 
        totalRecs: 0, 
        totalPages: 0,
        sections: []
      })
    }

    return new Promise((resolve) => {
      resolve(true)
    })
  },

  async fetchAutoQAEvalAgentTableSummary({getters, commit}, options) {
    let payload = {
      ...WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A)
    }
    payload[options.type] = options.value
    payload['sortColumn'] = options.sortColumn
    payload['sorting'] = options.sorting
    payload['pageNumber'] = options.pageNumber
    payload['pageSize'] = options.pageSize
    let res = await AutoQAService.fetchAutoQAEvalAgentTableSummary(getters.authUser, payload);
    if(res && res.data && res.data.results.length > 0) {
      res.data.results.forEach(item => {
        item.contactIdDisplay = item.contactId;
        item.dateDisplay = item.date;
        item.contactId = Number(item.contactId);
        item.date = moment(item.date).format("YYYY-MM-DD")
        item.overallScoreDisplay = item.overallScore.toFixed(2);
        res.data.sections.forEach(section => {
          let displayColumn = (section.replace(/\s(.)/g, function (a) {
            return a.toUpperCase();
          })
          .replace(/\s/g, '')
          .replace(/^(.)/, function (b) {
              return b.toLowerCase();
          })) + 'Display'
          item[displayColumn] = item[section].toFixed(2);
        })
        if(item.duration > 0) {
          item.durationDisplay = WyUtils.toNiceTimeFormat(item.duration / 1000)
        }
      })

      commit('updateTableModelResultWithDynamicColumns', {
        results: res.data.results, 
        totalRecs: res.data.totalRecords, 
        totalPages: res.data.totalPages,
        sections: res.data.sections
      })
    }
    else {
      commit('updateTableModelResultWithDynamicColumns', {
        results: [], 
        totalRecs: 0, 
        totalPages: 0,
        sections: []
      })
    }

    return new Promise((resolve) => {
      resolve(true)
    })
  },

  async fetchAutoQASummaryPanel({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await AutoQAService.fetchAutoQASummaryPanel(getters.authUser, payload);
    let viewByData = null;
    if (res && res.data) {
      viewByData = res.data;
    }
    return viewByData;
  },
  async fetchAutoQALineChart({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await AutoQAService.fetchAutoQALineChart(getters.authUser, payload);
    let viewByData = null;
    // res.data = {}
    if (res && res.data) {
      viewByData = res.data;
    }
    return viewByData;
  },
  async fetchAutoQABarChart({ getters }) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    let res = await AutoQAService.fetchAutoQABarChart(getters.authUser, payload);
    let viewByData = null;
    if (res && res.data) {
      viewByData = res.data;
    }
    return viewByData;
  },
  async fetchAutoQAEvalGroupTeamLineChart({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload[options.type] = options.value;
    // payload.agents = ['44']
    payload.displayName = options.displayName;
    payload.chartType = options.apiType;
    let res = await AutoQAService.fetchAutoQAEvalGroupTeamLineChart(getters.authUser, payload);
    let viewByData = null;
    // res.data = {}
    if (res && res.data) {
      // res.data.autoEvalScore.dailyMetrics.forEach(item => {
      //   item.rawData.totalAutoEvalScoreOverall = item.rawData.totalAutoEvalScore + 20
      //   item.rawData.totalConversationsOverall = item.rawData.totalConversations + 4
      //   item.value = item.rawData.totalAutoEvalScore;
      // })
      viewByData = res.data;
    }
    return viewByData;
  },

  async fetchAutoQAEvalGroupTeamBarChart({ getters }, options) {
    let payload = WyFilter.filterValues(getters.shareState, getters.dataModel, WyFilter.MODE_DATE_A);
    payload[options.type] = options.value
    
    let res = await AutoQAService.fetchAutoQAEvalGroupTeamBarChart(getters.authUser, payload);
    let viewByData = null;
    if (res && res.data) {
      viewByData = res.data;
    }
    return viewByData;
  },
  
};

export default {
  state,
  getters,
  mutations,
  actions,
};
